<template>
	<div class="speed-share">
		<Nav subNav="宽带提速" :isShowBack="1"></Nav>
		<div class="kdts-wrap">
			<div class="contact-wrap">
				<iframe
					:src="jumpUrl"
					sandbox="allow-scripts allow-top-navigation allow-same-origin"
				></iframe>
			</div>
			<div class="i-wrap">
				<iframe
					:src="url"
					sandbox="allow-scripts allow-top-navigation allow-same-origin"
					scrolling="no"
				></iframe>
			</div>
		</div>
	</div>
</template>
<script>
import Nav from "@/components/Common/Nav.vue";

export default {
	name: "Kdts",
	components: {
		Nav,
	},
	data: function () {
		return {
			url: "https://yc.ionewu.com/kdsj/?appid=WanWu",
			jumpUrl: "https://yc.ionewu.com/kdsj/?jump=service&appid=WanWu",
		};
	},
	methods: {},
	computed: {},
	watch: {},
	activated() {
		let _that = this;
		if (_that.$route.params.cur_pid) {
			// if (process.env.NODE_ENV !== "production") {
			// 	_that.url =
			// 		"http://192.168.71.66:8081/?appid=WanWu&pid=" +
			// 		_that.$route.params.cur_pid;
			// 	_that.jumpUrl =
			// 		"http://192.168.71.66:8081/?jump=service&appid=WanWu&pid=" +
			// 		_that.$route.params.cur_pid;
			// } else {
			// 	_that.url =
			// 		"https://yc.ionewu.com/kdsj/?appid=WanWu&pid=" +
			// 		_that.$route.params.cur_pid;
			// 	_that.jumpUrl =
			// 		"https://yc.ionewu.com/kdsj/?jump=service&appid=WanWu&pid=" +
			// 		_that.$route.params.cur_pid;
			// }

			_that.url =
				"https://yc.ionewu.com/kdsj_v3/?appid=WanWu&pid=" +
				_that.$route.params.cur_pid;
			_that.jumpUrl =
				"https://yc.ionewu.com/kdsj_v3/aboutforjdxbpc/?&appid=WanWu&pid=" +
				_that.$route.params.cur_pid;
		}
	},
	mounted() {},
};
</script>
<style lang="less" scoped>
.speed-share {
	height: 100%;
	position: relative;
	padding-top: 1px;

	.kdts-wrap {
		position: relative;
		margin: 0 auto;
		width: 940px;
		height: 500px;
		background-image: url("../assets/speedShare/a4.png");
		background-repeat: no-repeat;
		background-position: center;
		background-size: 100% 100%;
		box-sizing: border-box;
		text-align: center;

		.contact-wrap {
			display: inline-block;
			margin-right: 22px;
			margin-top: 45px;
			vertical-align: top;
			width: 420px;
			height: 416px;
			box-sizing: border-box;
			border: 1px solid #c9d9e7;
			border-radius: 4px;
			overflow: hidden;

			iframe {
				width: 100%;
				height: 100%;
			}
		}

		.i-wrap {
			display: inline-block;
			margin-top: 45px;
			vertical-align: top;
			width: 400px;
			height: 450px;
			box-sizing: border-box;

			iframe {
				width: 100%;
				height: 100%;
			}
		}
	}
}
</style>

